import { FormControl, FormHelperText, Grid } from "@mui/material";
import AutocompleteWithQuery from "components/AutocompleteWithQuery";
import Field from "components/Field";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  AdminListRequestOfBaseFilter,
  ListResponseOfLocationType,
} from "services/KnowfullyAdminClient";
import { MetaValueFieldProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

export function LocationTypeDropdownField({
  metaValueName,
  index,
  attributeMetaValues,
}: MetaValueFieldProps) {
  const { formatMessage: t } = useIntl();
  const { locationTypeService } = useGlobalContext();

  const fetchedData = useQuery<ListResponseOfLocationType>(
    ["locationTypeService.getLocationTypes"],
    () =>
      locationTypeService.getLocationTypes(
        AdminListRequestOfBaseFilter.fromJS({ sortField: "name" }),
      ),
  );

  const existingValue = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  return (
    <>
      <Field
        name={`attributeMetaValues[${index}].name`}
        initialValue={metaValueName}
      >
        {() => null}
      </Field>
      <Field
        name={`attributeMetaValues[${index}].value`}
        initialValue={existingValue ?? ""}
        required
      >
        {({ input, meta }) => (
          <Grid item xs={12}>
            <FormControl fullWidth error={meta.error && meta.submitFailed}>
              <AutocompleteWithQuery
                value={
                  input.value ? String(input.value).toLowerCase() : undefined
                }
                onChange={(id) => input.onChange(id ?? "")}
                fetchedData={fetchedData}
                labelField="name"
                label={t({ id: "locationFormTypeLabel" })}
                required
                failMessage={t({ id: "selectLocationTypeFetchFailed" })}
                textFieldProps={{ error: meta.error && meta.submitFailed }}
              />
              {meta.error && meta.submitFailed && (
                <FormHelperText>{meta.error}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        )}
      </Field>
    </>
  );
}
